export default __webpack_public_path__ + "static/project-slide-4-415-700-7e46d608bb1b38268b0faf1af1ad3d70.jpg";